import React, { useEffect, useState } from "react";
import { Table, Space, Spin, Modal, Input, Pagination, Button } from "antd";
import userServiceApi from "../../../src/api/userServiceApi";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getRequest, postRequest, deleteRequest } from "../../api/http";
import { toast } from "react-toastify";
import "./table.scss";
import backBtn from "../../assets/images/back-arrow.svg";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import detailsIcon from "../../assets/images/details-icon.svg";
import ViewMicrositeDetailsApproval from "./viewMicrositeDetailsApproval.js";
import { inputFieldCharLimit } from "../../config/index.js";

const HubPendingApprovalTable = ({
  activeKey,
  HidependingApprovalHandler,
  getPendingHubOrganizations,
  reloadFunction,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const lastPage = location.state.page;
  const [orgId, setOrgId] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [isShowPreview, setIsShowPreview] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [deleteAlertModal, setDeleteAlertModal] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [partnerId, setPartnerId] = useState(false);
  const [hubPendingId, setHubPendingId] = useState();
  const [reasonValue, setReasonValue] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [top, setTop] = useState("none");
  const [bottom, setBottom] = useState("none");
  const [totalOrgs, setTotalOrgs] = useState();
  const [micrositeModalDeatils, setMicrositeModalDetails] = useState(false);
  sessionStorage.setItem("page", "hub-pending");

  const approveOrDeniedData = async (value) => {
    // console.log(value);
    // console.log('reasonValue', reasonValue);
    try {
      if (value == "REJECT") {
        if (!reasonValue.trim()) {
          // Check if reasonValue contains only spaces
          toast.error("Please provide a rejection reason.");
          return;
        }
      }
      const response = await postRequest(userServiceApi.getReviews(partnerId), {
        action: value,
        rejectionReason: reasonValue ? reasonValue : "",
      });
      if (response) {
        ClearRow();
        setIsApproveModalOpen(false);
        setIsModalOpen(false);
        getPendingHubOrganizations();
        reloadFunction();
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  const closeModalDetails = () => {
    setMicrositeModalDetails(false);
    // reloadFunction();
    // window.location.reload();
    // getAllOrganizationsData();
  };

  const showDetailsHandler = (organisationId) => {
    setOrgId(organisationId);
    // sessionStorage.setItem("modal from member or restore", "member");
    setMicrositeModalDetails(true);
    // showSearchBarHandler();
    // showTagsHandler();
    // setMicrositeId(microsite && microsite);
  };

  const deletePendingOrg = async (value) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteOrganisation(value)
      );
      if (response) {
        toast.success(response);
        getPendingOrganizations();
        getPendingHubOrganizations();
        reloadFunction();
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  const Clear = () => {
    approveOrDeniedData("REJECT");
  };

  const Approve = () => {
    approveOrDeniedData("APPROVE");
  };

  const deleteHandler = () => {
    deletePendingOrg(hubPendingId);
    setDeleteAlertModal(false);
  };

  const handleDelete = (row) => {
    setDeleteAlertModal(true);
    setHubPendingId(row.id);
    // console.log("row", row)
  };

  const smallColumns = [
    {
      title: "Organisation Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "addressOutputs",
      key: "addressOutputs",
      render: (value, row) => {
        return <p>{value[0]?.street}</p>;
      },
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
      width: 150
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: " ",
      key: "action",
      render: (value, row, index) => (
        <Space size="middle">
          <div
            className="icon-style"
            onClick={() => showDetailsHandler(row?.id)}
          >
            <img src={detailsIcon} alt="Details" />
            {/* <div className="button-label">Details</div> */}
          </div>
          <Button
            label="Deny"
            className="table-deny-btn"
            onClick={() => showDenyModal(row.id)}
          >
            Deny
          </Button>
          <Button
            label="Approve"
            className="table-approve-btn"
            onClick={() => showApproveModal(row.id)}
          >
            Approve
          </Button>
          <img className="deleteIcon" src={deleteIcon} alt="" onClick={() => handleDelete(row)} />
        </Space>
      ),
    }
  ];

  const columns = [
    {
      title: "Organisation Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "addressOutputs",
      key: "addressOutputs",
      render: (value, row) => {
        return <p>{value[0]?.street}</p>;
      },
    },
    {
      title: "Organisaton Website",
      dataIndex: "websiteLink",
      key: "websiteLink",
      render: (value, row) => {
        return (
          <a href={`//${value}`} style={{ color: "blue" }} target="_blank">
            <p>{value}</p>
          </a>
        );
      },
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
      width: 150
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: " ",
      key: "action",
      render: (value, row, index) => (
        <Space size="middle">
          <div
            className="icon-style"
            onClick={() => showDetailsHandler(row?.id)}
          >
            <img src={detailsIcon} alt="Details" />
            {/* <div className="button-label">Details</div> */}
          </div>
          <Button
            label="Deny"
            className="table-deny-btn"
            onClick={() => showDenyModal(row.id)}
          >
            Deny
          </Button>
          <Button
            label="Approve"
            className="table-approve-btn"
            onClick={() => showApproveModal(row.id)}
          >
            Approve
          </Button>
          <img className="deleteIcon" src={deleteIcon} alt="" onClick={() => handleDelete(row)} />
        </Space>
      ),
    }
  ];

  const showDenyModal = (id) => {
    setPartnerId(id);
    setIsModalOpen(true);
  };

  const showApproveModal = (id) => {
    setPartnerId(id);
    setIsApproveModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsApproveModalOpen(false);
    setDeleteAlertModal(false);
  };
  const getPendingOrganizations = async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userServiceApi.getPendingHubApprovals(pageSize, pageNumber)
      );
      // console.log(response)
      if (response.data.result) {
        setTableData(response.data.result);
        setOrgId(response.data?.result.id);
        setTotalOrgs(response.data?.totalCount);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    if (activeKey == "2") {
      getPendingOrganizations();
    }
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [activeKey]);

  const pagNumber = (number) => {
    // console.log("Pagnumber", number)
    setPageNumber(number - 1);
  };

  useEffect(() => {
    
    getPendingOrganizations();
  }, [pageNumber]);

  const ClearRow = () => {
    getPendingOrganizations();
    setOrgId(null);
  };
  const reasonFieldChange = (e) => {
    setReasonValue(e.target.value);
  };

  if (loading || loader) {
    return (
      <div className="data-loader">
        <Spin className="spin" tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img src={backBtn} onClick={() => {
                if (lastPage === "hub-members") {
                  navigate('/hub-members')
                } else if (lastPage === "home") {
                  navigate('/partner-org')
                } else {
                  navigate('/partner-org')
                }
              }}
                alt="" />
              <p>Pending approvals - Hub members</p>
            </div>
          </div>
          <div className="table-container">
            <Table
              rowClassName={() => "rowClassName1"}
              columns={window.innerWidth >= 1440 ? columns : smallColumns}
              dataSource={tableData}
              pagination={{
                position: [top, bottom],
              }}
            />
            <Pagination
              className="pagination"
              // defaultCurrent={1}
              current={pageNumber + 1}
              pageSize={pageSize}
              total={totalOrgs}
              showTotal={(total) => `Pending approval for ${total} Organisations`}
              onChange={(page) => pagNumber(page)}
            />
          </div>

          {/* Deny Modal Popup Start */}
          <Modal
            className="confirmation-modal"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}
            closable={false}
            footer={null}
          >
            <div className="message">
              <p>Are you sure you want to Deny?</p>
            </div>
            <div className="dey-reason">
              <Input
                placeholder="Reason"
                value={reasonValue || ""}
                onChange={reasonFieldChange}
                maxLength={inputFieldCharLimit}
              />
            </div>
            <div className="modalBtns">
              <Button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="confirm-btn"
                onClick={Clear}
              >Deny</Button>
            </div>
          </Modal>
          <Modal
            className="confirmation-modal"
            open={isApproveModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}
            closable={false}
            footer={null}
          >
            <div className="message">
              <p>Are you sure you want to Approve?</p>
            </div>
            <div className="modalBtns">
              <Button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button className="confirm-btn" onClick={Approve}>
                Approve
              </Button>
            </div>
          </Modal>
          <Modal
            className="confirmation-modal"
            open={deleteAlertModal}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}
            closable={false}
            footer={null}
          >
            <div className="message">
              <p>Are you sure you want to Delete?</p>
            </div>
            <div className="modalBtns">
              <Button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="confirm-btn"
                onClick={deleteHandler}
              >Delete</Button>
            </div>
          </Modal>
          {micrositeModalDeatils ? (
            <ViewMicrositeDetailsApproval
              orgId={orgId}
              // HideViewMicrositeHandler={HideViewMicrositeHandler}
              // showSearchBarHandler={showSearchBarHandler}
              // showTagsHandler={showTagsHandler}
              closeModal={closeModalDetails}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
};
export default HubPendingApprovalTable;
